import { createContext, useContext } from 'react';

export type SearchFormConfig = Readonly<{
  dateRangeEnabled: boolean;
  occupancySelectorEnabled: boolean;
  isOpenedFormView: boolean;
  isCompactVersion?: boolean;
  isAnyFieldFocused: boolean;
}>;

export const DEFAULT_CONFIG: SearchFormConfig = {
  dateRangeEnabled: true,
  occupancySelectorEnabled: true,
  isOpenedFormView: false,
  isCompactVersion: false,
  isAnyFieldFocused: false,
} as const;

export const SearchFormConfigContext = createContext<SearchFormConfig>(DEFAULT_CONFIG);

export const useSearchFormConfig = () => {
  return useContext(SearchFormConfigContext);
};
